import { makeStyles } from "@material-ui/core";
import { Colors } from "../../helpers/theme";

const PoolCardStyle = makeStyles((theme) => ({
  root: {
    border: "1px solid rgba(17,48, 45, 0.1)",
    borderRadius: "15px",
    backgroundColor: Colors.darkWhite,
    display: "flex",
    height: "fit-content",
    flexDirection: "column",
    justifyContent: "space-between",
    transition: 'transform 0.3s ease-in-out',
    "&:hover": {
      transform: "scale(1.05)",
    },
  },
  rootClosed: {
    border: "none",
    borderRadius: "15px",
    backgroundColor: Colors.darkWhite,
    display: "flex",
    height: "fit-content",
    flexDirection: "column",
    justifyContent: "space-between",
    opacity: "80%",
  },
  skeleton: {
    border: "1px solid rgba(17,48, 45, 0.1)",
    borderRadius: "15px",
    display: "flex",
    height: "fit-content",
    flexDirection: "column",
    justifyContent: "space-between",
    backgroundColor: Colors.white,
  },
  media: {
    position: "relative",
  },
  chip_wrapper: {
    position: "absolute",
    top: 10,
    right: 20,
    zIndex: 1,
    display: "flex",
    gap: ".25rem",
  },
  chip: {
    minWidth: "60px",
    height: "34px",
    fontSize: "14px",
    fontWeight: 700,
    borderRadius: "23px",
    color: Colors.darkWhite,
    "&.green": {
      backgroundColor: Colors.PeurtoRico,
    },
    "&.darkGreen": {
      backgroundColor: Colors.greenDark,
    },
    "&.black": {
      backgroundColor: Colors.black,
    },
    "&.red": {
      backgroundColor: Colors.red,
    },
    "&.yellow": {
      backgroundColor: Colors.alertYellow,
    },
    "&.orange": {
      backgroundColor: Colors.orange,
    },
    "&.default": {
      backgroundColor: Colors.greySlate,
    },
  },
  iconWrapper: {
    backgroundColor: Colors.white,
    padding: "0 20px 0 20px",
    height: "50px !important",
  },
  iconWrapperClosed: {
    padding: "20px 20px 20px 20px",
    height: "50px !important",
  },
  avatar: {
    position: "relative",
    zIndex: 2,
    top: -45,
    width: "70px !important",
    height: "70px !important",
    mixBlendMode: "normal",
    border: "3px solid #FFFFFF",
    borderRadius: "100px",
    boxShadow: "0px 4px 15px 0px #0000001A",
    backgroundColor: Colors.white,
  },
  avatarClosed: {
    width: "40px !important",
    height: "40px !important",
    mixBlendMode: "normal",
    border: "3px solid #FFFFFF",
    borderRadius: "100px",
    boxShadow: "0px 4px 15px 0px #0000001A",
    backgroundColor: Colors.white,
  },
  network: {
    height: "32px !important",
    width: "32px !important",
  },
  alertContainer: {
    zIndex: 1,
    position: "absolute",
    top: 130,
    height: 30,
    minHeight: 30,
    width: "100%",
    backgroundColor: Colors.greySlate,
    display: "flex",
  },
  alert: {
    height: "inherit",
    margin: "0 0 0 100px",
    padding: "0 5px 0 5px",
    fontWeight: 600,
    fontSize: "14px",
    fontFamily: "Oxygen",
    color: Colors.alertYellow,
    backgroundColor: Colors.greySlate,
    display: "flex",
    alignItems: "center",
  },
  content: {
    backgroundColor: Colors.white,
    borderBottom: "1px solid rgba(17, 48, 45, 0.1)",
    borderRadius: "0 0 15px 15px",
    padding: "0 25px 0 25px !important",
  },
  contentClosed: {
    marginTop: "30px",
    borderRadius: "0 0 15px 15px",
    padding: "0 28px 0 28px !important",
  },
  title: {
    color: Colors.greenDark,
    fontSize: "22px",
    fontWeight: 700,
    lineHeight: "24px",
  },
  title2: {
    color: Colors.greenDark,
    fontSize: "16px",
    fontWeight: 700,
    lineHeight: "20px",
  },
  subtitle: {
    color: Colors.greenDark,
    fontSize: "14px",
    fontWeight: 700,
    lineHeight: "24px",
  },
  description: {
    color: Colors.greySlate,
    fontSize: "14px",
    fontWeight: 200,
    lineHeight: "22px",
    minHeight: "50px",
    maxHeight: "50px",
    overflow: "hidden",
  },
  detailContainerClosed: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    margin: "10px 0 10px 0",
    "& p": {
      color: Colors.blackLight,
      fontSize: "14px",
      fontWeight: 600,
    },
    "& .detailValue": {
      color: Colors.PeurtoRico,
      fontSize: "18px",
      fontWeight: 700,
    },
    "& .detailValue.darkSlate": {
      color: Colors.darkSlate,
      fontSize: "18px",
      fontWeight: 700,
    },
  },
  detailContainer: {
    margin: "10px 0 10px 0",
    minHeight: "90px !important",
    "& p": {
      color: Colors.blackLight,
      fontSize: "14px",
      fontWeight: 600,
    },
    "& .detailValue": {
      color: Colors.PeurtoRico,
      fontSize: "18px",
      fontWeight: 700,
    },
  },
  "& .smallValue": {
    color: Colors.blackLight,
    fontSize: "14px",
    fontWeight: 700,
  },
  socialIcons: {
    margin: "0 5px 0 0",
    fontSize: "16px",
    color: Colors.greySlate,
    "&.active": {
      color: Colors.darkSlate,
    },
  },
  progress: {
    backgroundColor: Colors.white,
    display: "block",
    margin: "10px 0 10px 0",
    "& p": {
      color: Colors.blackLight,
      fontSize: "14px",
      fontWeight: 700,
    },
  },
  progressContainer: {
    flexGrow: 1,
    position: "relative",
  },
  progressBar: {
    backgroundColor: Colors.Solitude,
    color: Colors.PeurtoRico,
  },
  progressMarkers: {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    margin: "0 5px 0 5px",
    "& p": {
      lineHeight: "inherit",
    },
  },
  progressError: {
    display: "flex",
    alignItems: "center",
    color: Colors.lightYellow,
  },
  actionContainer: {
    padding: "0 15px 0 15px",
    bottom: 0,
    position: "relative",
    justifyContent: "end",
  },
  actionText: {
    color: Colors.greySlate,
    fontSize: "14px",
    fontWeight: 600,
  },
  actionButton: {
    minWidth: "120px",
    padding: "10px",
    height: "50px",
    borderRadius: "78px",
    fontSize: "14px",
    backgroundColor: Colors.PeurtoRico,
    "&.Mui-disabled": {
      backgroundColor: Colors.greySlate,
      color: Colors.white,
    },
    "& span": {
      fontSize: "14px",
    },
  },
  countdown: {
    width: 140,
    backgroundColor: Colors.white,
    color: Colors.darkSlate,
    fontSize: "12px !important",
    fontWeight: 700,
    justifyContent: "space-around",
  },
}));

export default PoolCardStyle;
